import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useSelector } from 'react-redux';
import './commentshimmer.sass'

export default function CommentShimmer() {
    let isDark = useSelector(state => state.isDark);

    return ( 
        <div className='comment-shimmer-wrapper-container'>
            {isDark ?
                <SkeletonTheme highlightColor="#212426" color="#2D3134">
                    <div className='comment-shimmer-wrapper' >
                        <div className="comment-shimmer-img">
                            <Skeleton circle={true} width={40} height={40} />
                        </div>
                        <div className='comment-shimmer-mid'>
                            <Skeleton width={160} height={8} />
                            <div className='comment-shimmer-mid2'>
                            <Skeleton width={50} height={4} />
                            <div className='comment-shimmer-mid3'>
                            <Skeleton width={30} height={4} />
                            </div>
                            
                        </div>
                        </div>
                        
                        <div className='comment-shimmer-end'>
                            <Skeleton width={12} height={12} style={{borderRadius: '20px'}} />
                        </div>
                    </div>
                </SkeletonTheme> :
                <SkeletonTheme highlightColor="#F1F3F6" color="#ffffff">
                <div className='comment-shimmer-wrapper' >
                        <div className="comment-shimmer-img">
                            <Skeleton circle={true} width={40} height={40} />
                        </div>
                        <div className='comment-shimmer-mid'>
                            <Skeleton width={160} height={8} />
                            <div className='comment-shimmer-mid2'>
                            <Skeleton width={50} height={4} />
                            <div className='comment-shimmer-mid3'>
                            <Skeleton width={30} height={4} />
                            </div>
                            
                        </div>
                        </div>
                        
                        <div className='comment-shimmer-end'>
                            <Skeleton width={12} height={12} style={{borderRadius: '20px'}} />
                        </div>
                    </div>
                </SkeletonTheme>
            }
        </div>
    )
}
